import { render, staticRenderFns } from "./PlatformInfo.vue?vue&type=template&id=59b0b49d&"
import script from "./PlatformInfo.vue?vue&type=script&lang=js&"
export * from "./PlatformInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports